import React from 'react';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import {
  makeStyles
} from '@material-ui/core/styles';

import { Box, Typography } from '@material-ui/core';
import classNames from 'classnames';

export const primaryColor = '#181F28';
export const primarySelectedColor = 'rgb(0, 150, 136, 0.15)';
export const primaryHoverColor = 'rgb(0, 150, 136, 0.1)';
export const primaryPostHoverColor = 'rgb(0, 150, 136, 0.05)';
export const errorColor = '#f45858';
export const errorHoverColor = '#c24949';
export const errorContrastText = '#323232';

const useStyles = makeStyles((theme) => ({
  card: {
    cursor: 'pointer',
    borderRadius: 8,
    border: '1px solid #E5E5E5',
    transition: 'box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out',
    width: '100%',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  cardContent: {
    padding: theme.spacing(2),
    width: '100%',
    boxSizing: 'border-box',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  firstRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    flexWrap: 'wrap',
  },
  secondRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(1.5),
    alignItems: 'start',
    [theme.breakpoints.up(960)]: {
      gridTemplateColumns: 'auto 1fr auto auto',
      gap: theme.spacing(2),
    },
  },
  badge: {
    borderRadius: 8,
    padding: '2px 9px',
    color: '#FFFFFF',
    background: primaryColor,
    display: 'inline-flex !important',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    flexShrink: 0,
    width: 'auto !important',
    maxWidth: 'fit-content !important',
    alignSelf: 'flex-start',
    '&.MuiBox-root': {
      display: 'inline-flex !important',
      width: 'auto !important',
      maxWidth: 'fit-content !important',
    },
  },
  badgeValue: {
    fontWeight: 600,
    fontSize: 14,
  },
  info: {
    [theme.breakpoints.up(960)]: {
      gridColumn: '3',
      textAlign: 'right',
    },
  },
  infoLabel: {
    fontSize: 12,
    color: '#AAAAAA',
    fontWeight: 500,
    marginBottom: 4,
  },
  infoValue: {
    fontSize: 14,
    color: theme.palette.text.primary,
    wordBreak: 'break-word',
  },
  error: {
    color: '#EA2727',
  }
}))

interface IProps {
  badge: string;
  items: Array<{
    title: string;
    value: string | number;
    moneySymbol?: string;
    isError?: boolean;
  }>;
}

const SummaryCard: React.FC<IProps> = ({ badge, items }) => {
  const classes = useStyles();

  return (
    <Card className={classes.card} elevation={0}>
      <CardContent className={classes.cardContent}>
        <div className={classes.firstRow}
            style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}
          >
            <Box
              className={classes.badge}
              style={{ display: 'inline-flex', width: 'auto', maxWidth: 'fit-content', flexShrink: 0 }}
            >
              <Typography className={classes.badgeValue} component="span">
                { badge }
              </Typography>
            </Box>
        </div>
        <Box className={classes.secondRow}>
          {
            items.map(({ title, value, moneySymbol, isError }) => (
              <Box className={classes.info} key={title}>
                <Typography className={classes.infoLabel}>
                  { title }
                </Typography>
                <Typography className={classNames(classes.infoValue, { [classes.error]: isError })}>
                  {value} {moneySymbol}
                </Typography>
              </Box>
            ))
          }
        </Box>
      </CardContent>
    </Card>
  );
};

export default SummaryCard;
